import type {ValidationError} from 'Utility/validations/types';

const mapResponseToFormInputs = {
  first_name: {inputName: 'firstName'},
  last_name: {inputName: 'lastName'},
  suffix: {inputName: 'suffix'},
  street_address: {inputName: 'addressLine1'},
  unit2: {inputName: 'addressLine2'},
  city: {inputName: 'city'},
  country: {inputName: 'countryCode'},
  region: {inputName: 'regionCode'},
  postal_code: {inputName: 'postalCode'},
  date_of_birth: {inputName: 'dateOfBirth'},
  taxpayer_id: {inputName: 'tin', defaultMessage: 'Valid TIN required'},
  phone_number: {inputName: 'phoneNumber'},
  joint_holder_first_name: {inputName: 'firstNameSecondary'},
  joint_holder_last_name: {inputName: 'lastNameSecondary'},
  joint_holder_suffix: {inputName: 'suffixSecondary'},
  joint_holder_date_of_birth: {inputName: 'dateOfBirthSecondary'},
  joint_holder_taxpayer_id: {
    inputName: 'tinSecondary',
    defaultMessage: 'Valid TIN required',
  },
  joint_holder_country: {inputName: 'countryCodeSecondary'},
  joint_holder_street_address: {inputName: 'addressLine1Secondary'},
  joint_holder_unit2: {inputName: 'addressLine2Secondary'},
  joint_holder_city: {inputName: 'citySecondary'},
  joint_holder_region: {inputName: 'regionCodeSecondary'},
  joint_holder_postal_code: {inputName: 'postalCodeSecondary'},
};

export const buildValidationErrorsFromResponse = (
  errorResponse: object
): {
  [inputName: string]: ValidationError;
} => {
  const builtValidationErrors = {};

  Object.keys(errorResponse).forEach(field => {
    if (mapResponseToFormInputs[field]) {
      const {inputName, defaultMessage} = mapResponseToFormInputs[field];

      builtValidationErrors[inputName] = {
        error: true,
        fullErrorMessage: defaultMessage || errorResponse[field][0],
      };
    }
  });

  return builtValidationErrors;
};
